import { IonBackButton, IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
import SpacedRepetitionImg from '../images/help/spacedrepetition.png';
import PracticeTypesImg from '../images/help/practicetypes.png';
import SearchImg from '../images/help/search.png';
import H32 from '../images/help/3-2-min.png';
import Import1 from '../images/help/import-1.png';
import Import2 from '../images/help/import-2.png';
import '../styles/HelpGuide.scss';
import Utilities from '../Utilities';

class HelpGuide extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
        section: ""
      }
  }

  async componentDidMount() {
    Utilities.trackEvent("Help Guide", "Help Guide Page View", this.props.match.params.slug);
    this.setState({ section: this.props.match.params.slug })
  }

  render() {
    return (
      <IonPage data-page="help-guide">
        <IonHeader>
          <IonToolbar>
            <IonTitle>
              {
                (this.state.section === "spaced-repetition") ?  "Spaced Repetition & Practice Types" :
                (this.state.section === "search") ?  "Searching & Sorting" :
                (this.state.section === "pronunciation") ?  "Enable Pronunciations" :
                (this.state.section === "datacollection") ?  "Data Collection" :
                (this.state.section === "security") ?  "Data Security" :
                ""
              } 
            </IonTitle>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" text={window.ln.back} />
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent id="profile-settings-wrapper" fullscreen>
          { (this.state.section === "import") &&
            <div>
              <h1>Import from Other Sources</h1>
              <p>1. Go to the study set's page, and tap on the export button</p>
              <img src={Import1} />
              <p>2. Copy the text to the clipboard</p>
              <img src={Import2} />
              <p>3. Come back to this app, open the studyset you want to import into, tap import, paste the copied text, and tap import</p>
              {/* <video controls autoplay src="https://s3.amazonaws.com/helpsite-uploads/hfpnuvvpmw1e9gj8amtz5d3egvy%2FH0CQ5sXwiRg1607352968939-Quizlet.mp4"></video> */}
            </div>
          }
          { (this.state.section === "spaced-repetition") &&
            <div>
              <p>Spaced repetition leverages a memory phenomenon called the spacing effect, which describes how our brains learn more effectively when we space out our learning over time.</p>
              <p>The Flashcards made Simple app allows you to utilize spaced repetition in all 3 practice types. To get started simply start studying a study set or click on "New Cards" above the sets to study what you haven't studied yet.</p>
              <p>Once you reviewed some flashcards they will be scheduled to be reviewed again in 1, 2, 4, 8, and 16 days by default (you can change these in the settings).</p>
              <p>To review click on "Due Cards", make sure you review these right on the due date for the best result.</p>
              <img src={SpacedRepetitionImg} />
              <p>After selecting what you want to study, you can select the practice type, all 3 of them supports auto-marking the word as reviewed.</p>
              <img src={PracticeTypesImg} />
            </div>
          }
          { (this.state.section === "search") &&
            <div>
              <p>You can search by keywords or tags across all your study sets, or a specified studyset. To search across everything start searching from the study sets page. If you want to find something in a particular set go into that set and use the search bar and tags there.</p>
              <p>To Sort tap on the dropdown next to search, and select the new sorting criteria</p>
              <img src={SearchImg} />
            </div>
          }
          { (this.state.section === "pronunciation") &&
            <div>
              <p>Tap on "Edit" on a studyset, or create a new studyset</p>
              <p>Start typing the language of the term and definition, languages with a speaker icon support pronunciation, support is dependent on your current device.</p>
              <img src={H32} />
              <p>Once you selected a supported language pronunciation will be available on all cards in that set.</p>
            </div>
          }
          { (this.state.section === "security") &&
            <div>
              <p>By default, we don't collect or store any personal data, or other data created by you.</p>
              <p>If you enable Dropbox sync to backup your data, then we will use your own Dropbox account to sync everything (this data is only accessible by you)</p>
              <p>If you want to share flashcards with other users on our platform, then you have to create an account with an email address (only used for login, and never shared with other people), and username (visible by other people). All study sets that you share will be stored on our servers, so others can have access to it as well.</p>
              <p>We anonymously collect certain actions (e.g. study set created) without any context (e.g. the actual content of the study set), and we also log unexpected application errors, so we can identify and fix them.</p>
            </div>
          }
        </IonContent>
      </IonPage>
    )
  }
};

export default HelpGuide;
